module.exports = __webpack_public_path__ + "img/close.64e7cd79.svg";